import { render, staticRenderFns } from "./editSegmentation.vue?vue&type=template&id=05d4296c&"
import script from "./editSegmentation.vue?vue&type=script&lang=js&"
export * from "./editSegmentation.vue?vue&type=script&lang=js&"
import style0 from "./editSegmentation.vue?vue&type=style&index=0&id=05d4296c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports